// extracted by mini-css-extract-plugin
export default {"cls1":"WinBackPing-cls1___9054aed693cc0a29ae1","cls2":"WinBackPing-cls2__d2f2b2f7e1eeb3cb73b1 WinBackPing-cls1___9054aed693cc0a29ae1"};